/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: any; output: any; }
};

/** Input for approving an invite request (admin) */
export type ApproveInviteRequestInput = {
  /** Optional admin notes */
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  /** The invite request ID to approve */
  id: Scalars['String']['input'];
};

/** Payload for approveInviteRequest mutation */
export type ApproveInviteRequestPayload = {
  __typename?: 'ApproveInviteRequestPayload';
  invite?: Maybe<Invite>;
  inviteRequest?: Maybe<InviteRequest>;
  userErrors: Array<UserError>;
};

/** Type of asset being uploaded */
export type AssetType =
  /** Cover image */
  | 'IMAGE'
  /** Intro audio file */
  | 'INTRO'
  /** Outro audio file */
  | 'OUTRO';

/** Chapter metadata for podcast episodes */
export type Chapter = {
  __typename?: 'Chapter';
  /** Optional description or summary of this chapter */
  description?: Maybe<Scalars['String']['output']>;
  /** End time in milliseconds from the beginning of the episode */
  endTimeMs: Scalars['Int']['output'];
  /** Unique identifier for this chapter (e.g., "ch1", "ch2") */
  id: Scalars['String']['output'];
  /** Start time in milliseconds from the beginning of the episode */
  startTimeMs: Scalars['Int']['output'];
  /** Chapter title */
  title: Scalars['String']['output'];
};

/** Input for a chapter in an episode update */
export type ChapterInput = {
  /** Optional description or summary of this chapter */
  description?: InputMaybe<Scalars['String']['input']>;
  /** End time in milliseconds from the beginning of the episode */
  endTimeMs: Scalars['Int']['input'];
  /** Unique identifier for this chapter (e.g., "ch1", "ch2") */
  id: Scalars['String']['input'];
  /** Start time in milliseconds from the beginning of the episode */
  startTimeMs: Scalars['Int']['input'];
  /** Chapter title */
  title: Scalars['String']['input'];
};

/** Input for creating a new feature */
export type CreateFeatureInput = {
  description: Scalars['String']['input'];
  enabledForAll?: Scalars['Boolean']['input'];
  featureKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Payload for createFeature mutation */
export type CreateFeaturePayload = {
  __typename?: 'CreateFeaturePayload';
  feature?: Maybe<Feature>;
  featureEdge?: Maybe<FeatureEdge>;
  userErrors: Array<UserError>;
};

/** Input for creating a new topic */
export type CreateTopicInput = {
  /** Direct URL to the podcast on Apple Podcasts */
  applePodcastsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional cron schedule for automatic ingestion (e.g., "0 8 * * *") */
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  /** Custom host name for the podcast (e.g., "Alex Morgan") */
  customHostName?: InputMaybe<Scalars['String']['input']>;
  /** Custom personality prompt for the host */
  customHostPersonality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** RSS feed processing settings. Required when topicType is RSS. */
  rssSettings?: InputMaybe<RssSettingsInput>;
  s3AnchorImagePath?: InputMaybe<Scalars['String']['input']>;
  s3IntroPath?: InputMaybe<Scalars['String']['input']>;
  s3OutroPath?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sources: Array<SourceInput>;
  /** Direct URL to the podcast on Spotify */
  spotifyUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional style modifier that enhances the core prompt template.
   * Leave empty to use just the core template.
   */
  stylePrompt?: Scalars['String']['input'];
  /** Type of topic (NEWS or RSS). Defaults to NEWS for backwards compatibility. */
  topicType?: TopicType;
  /** TTS engine (defaults to Polly) */
  ttsEngine?: TtsEngine;
  /** Engine-specific model identifier (e.g., "eleven_flash_v2_5") */
  ttsModel?: InputMaybe<Scalars['String']['input']>;
  /** Topic visibility (defaults to Public) */
  visibility?: TopicVisibility;
  voiceId: Scalars['String']['input'];
};

/** Payload for createTopic mutation */
export type CreateTopicPayload = {
  __typename?: 'CreateTopicPayload';
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** Input for deleting an episode */
export type DeleteEpisodeInput = {
  episodeId: Scalars['String']['input'];
  topicSlug: Scalars['String']['input'];
};

/** Payload for deleteEpisode mutation */
export type DeleteEpisodePayload = {
  __typename?: 'DeleteEpisodePayload';
  deletedEpisodeId?: Maybe<Scalars['ID']['output']>;
  /** The topic that was mutated (with updated episode count) */
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** Input for deleting a feature */
export type DeleteFeatureInput = {
  featureKey: Scalars['String']['input'];
};

/** Payload for deleteFeature mutation */
export type DeleteFeaturePayload = {
  __typename?: 'DeleteFeaturePayload';
  deletedFeatureId?: Maybe<Scalars['ID']['output']>;
  deletedFeatureKey?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

/** Input for deleting a topic */
export type DeleteTopicInput = {
  slug: Scalars['String']['input'];
};

/** Payload for deleteTopic mutation */
export type DeleteTopicPayload = {
  __typename?: 'DeleteTopicPayload';
  deletedTopicId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Input for denying an invite request (admin) */
export type DenyInviteRequestInput = {
  /** Optional admin notes explaining the denial */
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  /** The invite request ID to deny */
  id: Scalars['String']['input'];
};

/** Payload for denyInviteRequest mutation */
export type DenyInviteRequestPayload = {
  __typename?: 'DenyInviteRequestPayload';
  inviteRequest?: Maybe<InviteRequest>;
  userErrors: Array<UserError>;
};

export type Episode = Node & {
  __typename?: 'Episode';
  audioS3Key: Scalars['String']['output'];
  chapters: Array<Chapter>;
  durationSeconds: Scalars['Int']['output'];
  episodeId: Scalars['String']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  /**
   * Whether the current viewer has liked this episode.
   * Returns null if the viewer is not authenticated.
   */
  isLikedByViewer?: Maybe<Scalars['Boolean']['output']>;
  /** Total number of likes for this episode. */
  likeCount: Scalars['Int']['output'];
  publishedAt: Scalars['DateTime']['output'];
  sourceLinks: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topicSlug: Scalars['String']['output'];
  transcript: Scalars['String']['output'];
  /**
   * The current viewer's listen progress for this episode.
   * Returns null if the viewer is not authenticated or hasn't started listening.
   */
  viewerListenProgress?: Maybe<ListenProgress>;
};

/** Paginated list of episodes */
export type EpisodeConnection = {
  __typename?: 'EpisodeConnection';
  edges: Array<EpisodeEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Edge wrapper for Episode in connections */
export type EpisodeEdge = {
  __typename?: 'EpisodeEdge';
  cursor: Scalars['String']['output'];
  node: Episode;
};

/** Step Functions execution status */
export type ExecutionStatus =
  /** Execution was aborted */
  | 'ABORTED'
  /** Execution failed */
  | 'FAILED'
  /** Execution is pending start */
  | 'PENDING_REDRIVE'
  /** Execution is currently running */
  | 'RUNNING'
  /** Execution completed successfully */
  | 'SUCCEEDED'
  /** Execution timed out */
  | 'TIMED_OUT';

export type Feature = Node & {
  __typename?: 'Feature';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabledForAll: Scalars['Boolean']['output'];
  enabledUserCount: Scalars['Int']['output'];
  featureKey: Scalars['String']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Feature assignment for a user */
export type FeatureAssignment = {
  __typename?: 'FeatureAssignment';
  enabled: Scalars['Boolean']['output'];
  featureKey: Scalars['String']['output'];
};

/** Paginated list of features */
export type FeatureConnection = {
  __typename?: 'FeatureConnection';
  edges: Array<FeatureEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge wrapper for Feature in connections */
export type FeatureEdge = {
  __typename?: 'FeatureEdge';
  cursor: Scalars['String']['output'];
  node: Feature;
};

export type FeatureFlagUser = Node & {
  __typename?: 'FeatureFlagUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  enabledFeatures: Array<Scalars['String']['output']>;
  featureAssignments: Array<FeatureAssignment>;
  /** Relay global ID */
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

/** Paginated list of users for feature flags */
export type FeatureFlagUserConnection = {
  __typename?: 'FeatureFlagUserConnection';
  edges: Array<FeatureFlagUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge wrapper for FeatureFlagUser in connections */
export type FeatureFlagUserEdge = {
  __typename?: 'FeatureFlagUserEdge';
  cursor: Scalars['String']['output'];
  node: FeatureFlagUser;
};

/** Input for a single feature toggle */
export type FeatureToggleInput = {
  enabled: Scalars['Boolean']['input'];
  featureKey: Scalars['String']['input'];
};

/** Input for following a topic */
export type FollowTopicInput = {
  topicSlug: Scalars['String']['input'];
};

/** Payload for followTopic mutation */
export type FollowTopicPayload = {
  __typename?: 'FollowTopicPayload';
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** Input for generating an upload URL */
export type GenerateUploadUrlInput = {
  /** Type of asset being uploaded */
  assetType: AssetType;
  /** MIME content type (e.g., "audio/mpeg", "image/jpeg") */
  contentType: Scalars['String']['input'];
  /** Original filename */
  fileName: Scalars['String']['input'];
  /** The topic slug this asset belongs to */
  topicSlug: Scalars['String']['input'];
};

/** Response containing the presigned upload URL */
export type GenerateUploadUrlPayload = {
  __typename?: 'GenerateUploadUrlPayload';
  /** URL expiration time in seconds */
  expiresIn?: Maybe<Scalars['Int']['output']>;
  /** S3 key where the file will be stored */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** Presigned URL for uploading the file via PUT */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  userErrors: Array<UserError>;
};

export type Invite = Node & {
  __typename?: 'Invite';
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type InviteRequest = Node & {
  __typename?: 'InviteRequest';
  adminNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  status: InviteRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of an invite request */
export type InviteRequestStatus =
  /** Request has been approved, invite sent */
  | 'APPROVED'
  /** Request was denied */
  | 'DENIED'
  /** Request is pending review */
  | 'PENDING';

/** Input for liking an episode */
export type LikeEpisodeInput = {
  episodeId: Scalars['String']['input'];
  topicSlug: Scalars['String']['input'];
};

/** Payload for likeEpisode mutation */
export type LikeEpisodePayload = {
  __typename?: 'LikeEpisodePayload';
  episode?: Maybe<Episode>;
  userErrors: Array<UserError>;
};

export type ListenHistoryConnection = {
  __typename?: 'ListenHistoryConnection';
  edges: Array<ListenHistoryEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ListenHistoryEdge = {
  __typename?: 'ListenHistoryEdge';
  cursor: Scalars['String']['output'];
  node: ListenHistoryEntry;
};

export type ListenHistoryEntry = Node & {
  __typename?: 'ListenHistoryEntry';
  /** Whether the episode has been completed */
  completed: Scalars['Boolean']['output'];
  /** Total duration of the episode in seconds */
  durationSeconds: Scalars['Int']['output'];
  /** The episode that was listened to (uses DataLoader for batch fetching) */
  episode: Episode;
  /** Relay global ID */
  id: Scalars['ID']['output'];
  /** When the progress was last updated */
  listenedAt: Scalars['DateTime']['output'];
  /** Current playback position in seconds */
  progressSeconds: Scalars['Int']['output'];
};

/** Listen progress for an episode (GraphQL type) */
export type ListenProgress = {
  __typename?: 'ListenProgress';
  completed: Scalars['Boolean']['output'];
  durationSeconds: Scalars['Int']['output'];
  episodeId: Scalars['String']['output'];
  listenedAt: Scalars['DateTime']['output'];
  progressSeconds: Scalars['Int']['output'];
  topicSlug: Scalars['String']['output'];
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  /** Approve an invite request (admin only) */
  approveInviteRequest: ApproveInviteRequestPayload;
  /** Create a new feature definition (admin only) */
  createFeature: CreateFeaturePayload;
  /** Create a new topic */
  createTopic: CreateTopicPayload;
  /** Delete an episode (admin only) */
  deleteEpisode: DeleteEpisodePayload;
  /**
   * Delete a feature definition (admin only)
   * Also removes the feature from all users
   */
  deleteFeature: DeleteFeaturePayload;
  /** Soft delete a topic (sets deleted_at timestamp) */
  deleteTopic: DeleteTopicPayload;
  /** Deny an invite request (admin only) */
  denyInviteRequest: DenyInviteRequestPayload;
  /** Follow a topic (requires authentication) */
  followTopic: FollowTopicPayload;
  /** Generate a presigned URL for uploading an asset */
  generateUploadUrl: GenerateUploadUrlPayload;
  /** Like an episode (requires authentication) */
  likeEpisode: LikeEpisodePayload;
  /** Record listen progress for an episode (requires authentication) */
  recordListenProgress: RecordListenProgressPayload;
  /** Redeem an invite (public - validates token and marks as redeemed) */
  redeemInvite: RedeemInvitePayload;
  /** Set a topic's active status */
  setTopicActive: SetTopicActivePayload;
  /** Set multiple features for multiple users at once (admin only) */
  setUserFeatures: SetUserFeaturesPayload;
  /** Submit an invite request (public - no auth required) */
  submitInviteRequest: SubmitInviteRequestPayload;
  /** Toggle a feature for multiple users (admin only) */
  toggleUserFeature: ToggleUserFeaturePayload;
  /** Trigger ingestion for a topic (async - starts Step Functions execution and returns immediately) */
  triggerIngestion: TriggerIngestionPayload;
  /** Trigger an RSS feed check for a topic (checks for new content and triggers ingestion if found) */
  triggerRssCheck: TriggerRssCheckPayload;
  /** Unfollow a topic (requires authentication) */
  unfollowTopic: UnfollowTopicPayload;
  /** Unlike an episode (requires authentication) */
  unlikeEpisode: UnlikeEpisodePayload;
  /** Update an episode (admin only) */
  updateEpisode: UpdateEpisodePayload;
  /** Update an existing feature definition (admin only) */
  updateFeature: UpdateFeaturePayload;
  /** Update the default prompt template (prompt config for Bedrock Prompt Management) */
  updatePromptTemplate: UpdatePromptTemplatePayload;
  /** Update source settings (admin only) */
  updateSourceSettings: UpdateSourceSettingsPayload;
  /** Update an existing topic */
  updateTopic: UpdateTopicPayload;
  /** Verify an email address (public - validates verification token) */
  verifyEmail: VerifyEmailPayload;
};


export type MutationRootApproveInviteRequestArgs = {
  input: ApproveInviteRequestInput;
};


export type MutationRootCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationRootCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationRootDeleteEpisodeArgs = {
  input: DeleteEpisodeInput;
};


export type MutationRootDeleteFeatureArgs = {
  input: DeleteFeatureInput;
};


export type MutationRootDeleteTopicArgs = {
  input: DeleteTopicInput;
};


export type MutationRootDenyInviteRequestArgs = {
  input: DenyInviteRequestInput;
};


export type MutationRootFollowTopicArgs = {
  input: FollowTopicInput;
};


export type MutationRootGenerateUploadUrlArgs = {
  input: GenerateUploadUrlInput;
};


export type MutationRootLikeEpisodeArgs = {
  input: LikeEpisodeInput;
};


export type MutationRootRecordListenProgressArgs = {
  input: RecordListenProgressInput;
};


export type MutationRootRedeemInviteArgs = {
  input: RedeemInviteInput;
};


export type MutationRootSetTopicActiveArgs = {
  input: SetTopicActiveInput;
};


export type MutationRootSetUserFeaturesArgs = {
  input: SetUserFeaturesInput;
};


export type MutationRootSubmitInviteRequestArgs = {
  input: SubmitInviteRequestInput;
};


export type MutationRootToggleUserFeatureArgs = {
  input: ToggleUserFeatureInput;
};


export type MutationRootTriggerIngestionArgs = {
  input: TriggerIngestionInput;
};


export type MutationRootTriggerRssCheckArgs = {
  input: TriggerRssCheckInput;
};


export type MutationRootUnfollowTopicArgs = {
  input: UnfollowTopicInput;
};


export type MutationRootUnlikeEpisodeArgs = {
  input: UnlikeEpisodeInput;
};


export type MutationRootUpdateEpisodeArgs = {
  input: UpdateEpisodeInput;
};


export type MutationRootUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationRootUpdatePromptTemplateArgs = {
  input: UpdatePromptConfigInput;
};


export type MutationRootUpdateSourceSettingsArgs = {
  input: UpdateSourceSettingsInput;
};


export type MutationRootUpdateTopicArgs = {
  input: UpdateTopicInput;
  slug: Scalars['String']['input'];
};


export type MutationRootVerifyEmailArgs = {
  input: VerifyEmailInput;
};

/** Relay Node interface for global object identification */
export type Node = {
  /** Global object identifier */
  id: Scalars['ID']['output'];
};

/** Pagination information for connections */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PromptConfig = Node & {
  __typename?: 'PromptConfig';
  /** The name of the prompt in Bedrock Prompt Management */
  bedrockPromptName: Scalars['String']['output'];
  /** Unique identifier for this config */
  configId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QueryRoot = {
  __typename?: 'QueryRoot';
  /** Get a single episode by global ID */
  episode?: Maybe<Episode>;
  /**
   * Get episodes for a topic (connection with cursor pagination).
   * When topicSlug is omitted, returns recent episodes across all public topics.
   */
  episodes: EpisodeConnection;
  /** Get a single feature by its key (admin only) */
  feature?: Maybe<Feature>;
  /** Get a specific user by email (admin only) */
  featureFlagUser?: Maybe<FeatureFlagUser>;
  /** Get all users with pagination and optional search (admin only) */
  featureFlagUsers: FeatureFlagUserConnection;
  /** Get all feature definitions with pagination (admin only) */
  features: FeatureConnection;
  /** Get topics followed by the current viewer (requires auth) */
  followedTopics: TopicConnection;
  /** Get a specific invite request by ID (admin only) */
  inviteRequest?: Maybe<InviteRequest>;
  /** Get all invite requests (admin only) */
  inviteRequests: Array<InviteRequest>;
  /** Get episodes liked by the current viewer (requires auth) */
  likedEpisodes: EpisodeConnection;
  /** Get listening history for the current viewer (requires auth) */
  listeningHistory: ListenHistoryConnection;
  /** Get new episodes from topics the current viewer follows (requires auth) */
  newEpisodesFromFollowed: EpisodeConnection;
  /** Relay node query - fetch any object by global ID */
  node?: Maybe<Node>;
  /** Relay batch node query - fetch multiple objects by global IDs */
  nodes: Array<Maybe<Node>>;
  ping: Scalars['String']['output'];
  /** Get the default prompt template (creates one if it doesn't exist) */
  promptTemplate: PromptConfig;
  /** Get the source settings (creates defaults if they don't exist) */
  sourceSettings: SourceSettings;
  /** Get a topic by slug */
  topic?: Maybe<Topic>;
  /** Paginated topics list (excludes soft-deleted topics) */
  topics: TopicConnection;
  /** Check if an invite token is valid (public) */
  validateInvite?: Maybe<Invite>;
  /**
   * Get the current viewer (authenticated user).
   * Returns null if not authenticated.
   * The viewer includes their enabled features.
   */
  viewer?: Maybe<ViewerWithFeatures>;
};


export type QueryRootEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRootEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  topicSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRootFeatureArgs = {
  featureKey: Scalars['String']['input'];
};


export type QueryRootFeatureFlagUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryRootFeatureFlagUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRootFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootFollowedTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootInviteRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryRootInviteRequestsArgs = {
  status?: InputMaybe<InviteRequestStatus>;
};


export type QueryRootLikedEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootListeningHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootNewEpisodesFromFollowedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRootNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRootTopicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRootTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<TopicVisibility>;
};


export type QueryRootValidateInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryRootViewerArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for recording listen progress */
export type RecordListenProgressInput = {
  durationSeconds: Scalars['Int']['input'];
  episodeId: Scalars['String']['input'];
  progressSeconds: Scalars['Int']['input'];
  topicSlug: Scalars['String']['input'];
};

/** Payload for recordListenProgress mutation */
export type RecordListenProgressPayload = {
  __typename?: 'RecordListenProgressPayload';
  listenProgress?: Maybe<ListenProgress>;
  userErrors: Array<UserError>;
};

/** Input for redeeming an invite */
export type RedeemInviteInput = {
  /** The invite token */
  token: Scalars['String']['input'];
};

/** Payload for redeemInvite mutation */
export type RedeemInvitePayload = {
  __typename?: 'RedeemInvitePayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Maximum age of RSS items to process */
export type RssMaxAge =
  /** Only process items from the last 24 hours */
  | 'ONE_DAY'
  /** Only process items from the last 30 days */
  | 'ONE_MONTH'
  /** Only process items from the last 7 days */
  | 'ONE_WEEK';

/** Maximum number of RSS items to include in a single episode */
export type RssMaxItemsPerEpisode =
  /** Include up to five items per episode */
  | 'FIVE'
  /** Include only one item per episode */
  | 'ONE'
  /** Include up to ten items per episode */
  | 'TEN'
  /** Include up to three items per episode */
  | 'THREE';

/** Delay before processing new RSS items (allows for edits/corrections) */
export type RssProcessingDelay =
  /** Process immediately when detected */
  | 'INSTANT'
  /** Wait 24 hours before processing */
  | 'ONE_DAY'
  /** Wait 1 hour before processing */
  | 'ONE_HOUR'
  /** Wait 6 hours before processing */
  | 'SIX_HOURS'
  /** Wait 48 hours before processing */
  | 'TWO_DAYS';

/** RSS feed processing settings for RSS-type topics */
export type RssSettings = {
  __typename?: 'RssSettings';
  /** Maximum age of items to process */
  maxAge: RssMaxAge;
  /** Maximum number of items to include in a single episode */
  maxItemsPerEpisode: RssMaxItemsPerEpisode;
  /** Delay before processing new items */
  processingDelay: RssProcessingDelay;
};

/** Input for RSS feed processing settings */
export type RssSettingsInput = {
  /** Maximum age of items to process */
  maxAge: RssMaxAge;
  /** Maximum number of items to include in a single episode */
  maxItemsPerEpisode: RssMaxItemsPerEpisode;
  /** Delay before processing new items */
  processingDelay: RssProcessingDelay;
};

/** Input for setting topic active status */
export type SetTopicActiveInput = {
  isActive: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

/** Payload for setTopicActive mutation */
export type SetTopicActivePayload = {
  __typename?: 'SetTopicActivePayload';
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** Input for setting multiple features for users */
export type SetUserFeaturesInput = {
  features: Array<FeatureToggleInput>;
  userEmails: Array<Scalars['String']['input']>;
};

/** Payload for setUserFeatures mutation */
export type SetUserFeaturesPayload = {
  __typename?: 'SetUserFeaturesPayload';
  features: Array<Feature>;
  userErrors: Array<UserError>;
};

/** Source configuration for fetching content */
export type Source = {
  __typename?: 'Source';
  /** Optional domain filter for News sources (comma-separated list) */
  domainFilter?: Maybe<Scalars['String']['output']>;
  /** Identifier (keywords/topics for News, URL for RSS) */
  identifier: Scalars['String']['output'];
  /** Optional label for the source */
  label?: Maybe<Scalars['String']['output']>;
  /** Source type */
  sourceType: SourceType;
};

export type SourceInput = {
  domainFilter?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  sourceType: SourceType;
};

export type SourceSettings = Node & {
  __typename?: 'SourceSettings';
  /** Number of Bing News results to fetch (10-100) */
  bingResultCount: Scalars['Int']['output'];
  /** Unique identifier for this config */
  configId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  /** Number of Serper News results to fetch (10-100) */
  serperResultCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Types of content sources */
export type SourceType =
  /** Bing News RSS feed */
  | 'BING_NEWS'
  /** Google News RSS feed */
  | 'GOOGLE_NEWS'
  /** Reddit subreddit (legacy - disabled in UI) */
  | 'REDDIT'
  /** Generic RSS feed - supports instant episode generation */
  | 'RSS'
  /** Serper.dev News API */
  | 'SERPER_NEWS'
  /** X/Twitter (legacy - disabled in UI) */
  | 'TWITTER'
  /** YouTube channel (legacy - disabled in UI) */
  | 'YOU_TUBE';

/** Input for submitting an invite request (public) */
export type SubmitInviteRequestInput = {
  email: Scalars['String']['input'];
};

/** Payload for submitInviteRequest mutation */
export type SubmitInviteRequestPayload = {
  __typename?: 'SubmitInviteRequestPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Input for toggling a feature for users */
export type ToggleUserFeatureInput = {
  enabled: Scalars['Boolean']['input'];
  featureKey: Scalars['String']['input'];
  userEmails: Array<Scalars['String']['input']>;
};

/** Payload for toggleUserFeature mutation */
export type ToggleUserFeaturePayload = {
  __typename?: 'ToggleUserFeaturePayload';
  feature?: Maybe<Feature>;
  userErrors: Array<UserError>;
};

export type Topic = Node & {
  __typename?: 'Topic';
  applePodcastsUrl?: Maybe<Scalars['String']['output']>;
  /** Check if a specific action can be performed on this topic */
  canAct: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  cronSchedule?: Maybe<Scalars['String']['output']>;
  customHostName?: Maybe<Scalars['String']['output']>;
  customHostPersonality?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Total number of episodes for this topic (denormalized) */
  episodeCount: Scalars['Int']['output'];
  /** Paginated episodes for this topic */
  episodes: EpisodeConnection;
  /** Total number of followers for this topic. */
  followerCount: Scalars['Int']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /**
   * Whether the current viewer is following this topic.
   * Returns null if the viewer is not authenticated.
   */
  isFollowedByViewer?: Maybe<Scalars['Boolean']['output']>;
  /** Step Functions execution ARN for the last/current ingestion run */
  lastExecutionId?: Maybe<Scalars['String']['output']>;
  /** When the last/current execution was started */
  lastExecutionStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the last/current Step Functions execution */
  lastExecutionStatus?: Maybe<ExecutionStatus>;
  lastIngestionAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** RSS-specific settings (only relevant when topicType is RSS) */
  rssSettings?: Maybe<RssSettings>;
  s3AnchorImagePath?: Maybe<Scalars['String']['output']>;
  s3IntroPath?: Maybe<Scalars['String']['output']>;
  s3OutroPath?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sources: Array<Source>;
  spotifyUrl?: Maybe<Scalars['String']['output']>;
  status: TopicStatus;
  stylePrompt: Scalars['String']['output'];
  /** Type of topic (NEWS or RSS) - determines ingestion behavior */
  topicType: TopicType;
  ttsEngine: TtsEngine;
  ttsModel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  visibility: TopicVisibility;
  voiceId: Scalars['String']['output'];
};


export type TopicCanActArgs = {
  action: TopicAction;
};


export type TopicEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Actions that can be performed on a topic */
export type TopicAction =
  /** Trigger content ingestion for this topic */
  | 'TRIGGER_INGESTION';

/** Paginated list of topics */
export type TopicConnection = {
  __typename?: 'TopicConnection';
  edges: Array<TopicEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Edge wrapper for Topic in connections */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  cursor: Scalars['String']['output'];
  node: Topic;
};

/** Topic ingestion status */
export type TopicStatus =
  /** Topic is idle and can be scheduled */
  | 'IDLE'
  /** Topic ingestion is currently running */
  | 'RUNNING';

/** Type of topic - determines ingestion behavior */
export type TopicType =
  /** News aggregation topic with scheduled cron-based ingestion */
  | 'NEWS'
  /** RSS feed monitoring topic with 5-minute polling for instant episodes */
  | 'RSS';

/** Topic visibility level (YouTube-style) */
export type TopicVisibility =
  /** Only visible to the owner */
  | 'PRIVATE'
  /** Shown on discovery page, accessible by anyone */
  | 'PUBLIC'
  /** Not shown on discovery page, but accessible via direct link */
  | 'UNLISTED';

/** Input for triggering ingestion */
export type TriggerIngestionInput = {
  topicSlug: Scalars['String']['input'];
};

/** Payload for triggerIngestion mutation (async - returns immediately) */
export type TriggerIngestionPayload = {
  __typename?: 'TriggerIngestionPayload';
  /** Human-readable message about the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the ingestion was successfully started (or failed validation) */
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Input for manually triggering an RSS feed check */
export type TriggerRssCheckInput = {
  /** The topic slug to check for new RSS content */
  topicSlug: Scalars['String']['input'];
};

/** Payload for triggerRssCheck mutation */
export type TriggerRssCheckPayload = {
  __typename?: 'TriggerRssCheckPayload';
  /** Number of RSS feeds checked */
  feedsChecked: Scalars['Int']['output'];
  /** Whether an ingestion was triggered */
  ingestionTriggered: Scalars['Boolean']['output'];
  /** Human-readable message about the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Number of new content items found */
  newContentFound: Scalars['Int']['output'];
  /** Whether the check was performed successfully */
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

/** Text-to-speech engine for synthesizing episode audio */
export type TtsEngine =
  /**
   * ElevenLabs (sync synthesis via /v1/text-to-speech/{voice_id}/with-timestamps).
   * Falls back to Polly on failure when configured.
   */
  | 'ELEVEN_LABS'
  /** Amazon Polly (default, async synthesis via StartSpeechSynthesisTask) */
  | 'POLLY';

/** Input for unfollowing a topic */
export type UnfollowTopicInput = {
  topicSlug: Scalars['String']['input'];
};

/** Payload for unfollowTopic mutation */
export type UnfollowTopicPayload = {
  __typename?: 'UnfollowTopicPayload';
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** Input for unliking an episode */
export type UnlikeEpisodeInput = {
  episodeId: Scalars['String']['input'];
  topicSlug: Scalars['String']['input'];
};

/** Payload for unlikeEpisode mutation */
export type UnlikeEpisodePayload = {
  __typename?: 'UnlikeEpisodePayload';
  episode?: Maybe<Episode>;
  userErrors: Array<UserError>;
};

/** Input for updating an episode */
export type UpdateEpisodeInput = {
  /** Chapter markers for the episode */
  chapters?: InputMaybe<Array<ChapterInput>>;
  episodeId: Scalars['String']['input'];
  /** Links to source content */
  sourceLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Episode summary/description */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Episode title */
  title?: InputMaybe<Scalars['String']['input']>;
  topicSlug: Scalars['String']['input'];
  /** Full transcript */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for updateEpisode mutation */
export type UpdateEpisodePayload = {
  __typename?: 'UpdateEpisodePayload';
  episode?: Maybe<Episode>;
  userErrors: Array<UserError>;
};

/** Input for updating a feature */
export type UpdateFeatureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabledForAll?: InputMaybe<Scalars['Boolean']['input']>;
  featureKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for updateFeature mutation */
export type UpdateFeaturePayload = {
  __typename?: 'UpdateFeaturePayload';
  feature?: Maybe<Feature>;
  userErrors: Array<UserError>;
};

/**
 * Input for updating the prompt configuration
 *
 * The prompt name must reference an existing prompt in Bedrock Prompt Management.
 * The mutation will validate that the prompt exists before saving.
 */
export type UpdatePromptConfigInput = {
  /**
   * The name of the prompt in Bedrock Prompt Management
   * Must match an existing prompt name in your AWS account
   */
  bedrockPromptName: Scalars['String']['input'];
};

/** Payload for updatePromptTemplate mutation */
export type UpdatePromptTemplatePayload = {
  __typename?: 'UpdatePromptTemplatePayload';
  promptTemplate?: Maybe<PromptConfig>;
  userErrors: Array<UserError>;
};

/** Input for updating source settings */
export type UpdateSourceSettingsInput = {
  /** Number of Bing News results to fetch (10-100, in increments of 10) */
  bingResultCount: Scalars['Int']['input'];
  /** Number of Serper News results to fetch (10-100, in increments of 10) */
  serperResultCount: Scalars['Int']['input'];
};

/** Payload for updateSourceSettings mutation */
export type UpdateSourceSettingsPayload = {
  __typename?: 'UpdateSourceSettingsPayload';
  sourceSettings?: Maybe<SourceSettings>;
  userErrors: Array<UserError>;
};

/** Input for updating a topic */
export type UpdateTopicInput = {
  /** Direct URL to the podcast on Apple Podcasts */
  applePodcastsUrl?: InputMaybe<Scalars['String']['input']>;
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  /** Custom host name for the podcast (e.g., "Alex Morgan") */
  customHostName?: InputMaybe<Scalars['String']['input']>;
  /** Custom personality prompt for the host */
  customHostPersonality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** RSS feed processing settings */
  rssSettings?: InputMaybe<RssSettingsInput>;
  s3AnchorImagePath?: InputMaybe<Scalars['String']['input']>;
  s3IntroPath?: InputMaybe<Scalars['String']['input']>;
  s3OutroPath?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<SourceInput>>;
  /** Direct URL to the podcast on Spotify */
  spotifyUrl?: InputMaybe<Scalars['String']['input']>;
  stylePrompt?: InputMaybe<Scalars['String']['input']>;
  /** Type of topic (NEWS or RSS) */
  topicType?: InputMaybe<TopicType>;
  /** TTS engine */
  ttsEngine?: InputMaybe<TtsEngine>;
  /** Engine-specific model identifier. Empty string clears the field. */
  ttsModel?: InputMaybe<Scalars['String']['input']>;
  /** Topic visibility (Public, Unlisted, Private) */
  visibility?: InputMaybe<TopicVisibility>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for updateTopic mutation */
export type UpdateTopicPayload = {
  __typename?: 'UpdateTopicPayload';
  topic?: Maybe<Topic>;
  userErrors: Array<UserError>;
};

/** User-facing error from a mutation */
export type UserError = {
  __typename?: 'UserError';
  /** Error code for programmatic handling */
  code?: Maybe<Scalars['String']['output']>;
  /** Field that caused the error, if applicable */
  field?: Maybe<Scalars['String']['output']>;
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

/** Input for verifying an email address */
export type VerifyEmailInput = {
  /** The verification token from the email */
  token: Scalars['String']['input'];
};

/** Payload for verifyEmail mutation */
export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userErrors: Array<UserError>;
};

export type Viewer = Node & {
  __typename?: 'Viewer';
  email: Scalars['String']['output'];
  /** Relay global ID */
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type ViewerWithFeatures = {
  __typename?: 'ViewerWithFeatures';
  email: Scalars['String']['output'];
  /** Enabled feature keys for this user (respects keys filter from query) */
  features: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the user has admin privileges */
  isAdmin: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /** User's role (e.g., "admin" or "user") */
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UpdateEpisodeMutationVariables = Exact<{
  input: UpdateEpisodeInput;
}>;


export type UpdateEpisodeMutation = { __typename?: 'MutationRoot', updateEpisode: { __typename?: 'UpdateEpisodePayload', episode?: { __typename?: 'Episode', id: string, topicSlug: string, episodeId: string, title: string, summary: string, audioS3Key: string, transcript: string, sourceLinks: Array<string>, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> } | null } };

export type GetEpisodeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEpisodeByIdQuery = { __typename?: 'QueryRoot', episode?: { __typename?: 'Episode', id: string, topicSlug: string, episodeId: string, title: string, summary: string, audioS3Key: string, transcript: string, sourceLinks: Array<string>, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> } | null };

export type PromptConfigFieldsFragment = { __typename?: 'PromptConfig', id: string, configId: string, bedrockPromptName: string, createdAt: any, updatedAt: any };

export type GetPromptTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromptTemplateQuery = { __typename?: 'QueryRoot', promptTemplate: { __typename?: 'PromptConfig', id: string, configId: string, bedrockPromptName: string, createdAt: any, updatedAt: any } };

export type UpdatePromptTemplateMutationVariables = Exact<{
  input: UpdatePromptConfigInput;
}>;


export type UpdatePromptTemplateMutation = { __typename?: 'MutationRoot', updatePromptTemplate: { __typename?: 'UpdatePromptTemplatePayload', promptTemplate?: { __typename?: 'PromptConfig', id: string, configId: string, bedrockPromptName: string, createdAt: any, updatedAt: any } | null } };

export type SourceFieldsFragment = { __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null };

export type TopicFieldsFragment = { __typename?: 'Topic', id: string, slug: string, name: string, voiceId: string, ttsEngine: TtsEngine, ttsModel?: string | null, stylePrompt: string, customHostName?: string | null, customHostPersonality?: string | null, s3IntroPath?: string | null, s3OutroPath?: string | null, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isActive: boolean, visibility: TopicVisibility, cronSchedule?: string | null, status: TopicStatus, episodeCount: number, lastIngestionAt?: any | null, lastExecutionId?: string | null, lastExecutionStatus?: ExecutionStatus | null, lastExecutionStartedAt?: any | null, createdAt: any, createdBy?: string | null, updatedAt: any, updatedBy?: string | null, canTriggerIngestion: boolean, sources: Array<{ __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null }>, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, publishedAt: any } }> } };

export type TopicSummaryFieldsFragment = { __typename?: 'Topic', id: string, slug: string, name: string, isActive: boolean, visibility: TopicVisibility, episodeCount: number, createdAt: any, updatedAt: any };

export type GetTopicsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTopicsQuery = { __typename?: 'QueryRoot', topics: { __typename?: 'TopicConnection', edges: Array<{ __typename?: 'TopicEdge', cursor: string, node: { __typename?: 'Topic', id: string, slug: string, name: string, voiceId: string, ttsEngine: TtsEngine, ttsModel?: string | null, stylePrompt: string, customHostName?: string | null, customHostPersonality?: string | null, s3IntroPath?: string | null, s3OutroPath?: string | null, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isActive: boolean, visibility: TopicVisibility, cronSchedule?: string | null, status: TopicStatus, episodeCount: number, lastIngestionAt?: any | null, lastExecutionId?: string | null, lastExecutionStatus?: ExecutionStatus | null, lastExecutionStartedAt?: any | null, createdAt: any, createdBy?: string | null, updatedAt: any, updatedBy?: string | null, canTriggerIngestion: boolean, sources: Array<{ __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null }>, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, publishedAt: any } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetTopicQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetTopicQuery = { __typename?: 'QueryRoot', topic?: { __typename?: 'Topic', id: string, slug: string, name: string, voiceId: string, ttsEngine: TtsEngine, ttsModel?: string | null, stylePrompt: string, customHostName?: string | null, customHostPersonality?: string | null, s3IntroPath?: string | null, s3OutroPath?: string | null, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isActive: boolean, visibility: TopicVisibility, cronSchedule?: string | null, status: TopicStatus, episodeCount: number, lastIngestionAt?: any | null, lastExecutionId?: string | null, lastExecutionStatus?: ExecutionStatus | null, lastExecutionStartedAt?: any | null, createdAt: any, createdBy?: string | null, updatedAt: any, updatedBy?: string | null, canTriggerIngestion: boolean, sources: Array<{ __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null }>, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, publishedAt: any } }> } } | null };

export type CreateTopicMutationVariables = Exact<{
  input: CreateTopicInput;
}>;


export type CreateTopicMutation = { __typename?: 'MutationRoot', createTopic: { __typename?: 'CreateTopicPayload', topic?: { __typename?: 'Topic', id: string, slug: string, name: string, isActive: boolean, visibility: TopicVisibility, episodeCount: number, createdAt: any, updatedAt: any } | null } };

export type SetTopicActiveMutationVariables = Exact<{
  input: SetTopicActiveInput;
}>;


export type SetTopicActiveMutation = { __typename?: 'MutationRoot', setTopicActive: { __typename?: 'SetTopicActivePayload', topic?: { __typename?: 'Topic', id: string, slug: string, isActive: boolean, updatedAt: any } | null } };

export type UpdateTopicMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  input: UpdateTopicInput;
}>;


export type UpdateTopicMutation = { __typename?: 'MutationRoot', updateTopic: { __typename?: 'UpdateTopicPayload', topic?: { __typename?: 'Topic', id: string, slug: string, name: string, voiceId: string, ttsEngine: TtsEngine, ttsModel?: string | null, stylePrompt: string, customHostName?: string | null, customHostPersonality?: string | null, s3IntroPath?: string | null, s3OutroPath?: string | null, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isActive: boolean, visibility: TopicVisibility, cronSchedule?: string | null, status: TopicStatus, episodeCount: number, lastIngestionAt?: any | null, lastExecutionId?: string | null, lastExecutionStatus?: ExecutionStatus | null, lastExecutionStartedAt?: any | null, createdAt: any, createdBy?: string | null, updatedAt: any, updatedBy?: string | null, canTriggerIngestion: boolean, sources: Array<{ __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null }>, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, publishedAt: any } }> } } | null } };

export type DeleteTopicMutationVariables = Exact<{
  input: DeleteTopicInput;
}>;


export type DeleteTopicMutation = { __typename?: 'MutationRoot', deleteTopic: { __typename?: 'DeleteTopicPayload', deletedTopicId?: string | null, success: boolean } };

export type GenerateUploadUrlMutationVariables = Exact<{
  input: GenerateUploadUrlInput;
}>;


export type GenerateUploadUrlMutation = { __typename?: 'MutationRoot', generateUploadUrl: { __typename?: 'GenerateUploadUrlPayload', uploadUrl?: string | null, s3Key?: string | null, expiresIn?: number | null } };

export type TriggerIngestionMutationVariables = Exact<{
  input: TriggerIngestionInput;
}>;


export type TriggerIngestionMutation = { __typename?: 'MutationRoot', triggerIngestion: { __typename?: 'TriggerIngestionPayload', success: boolean, message?: string | null } };

export type DeleteEpisodeMutationVariables = Exact<{
  input: DeleteEpisodeInput;
}>;


export type DeleteEpisodeMutation = { __typename?: 'MutationRoot', deleteEpisode: { __typename?: 'DeleteEpisodePayload', deletedEpisodeId?: string | null, topic?: { __typename?: 'Topic', id: string, slug: string, name: string, voiceId: string, ttsEngine: TtsEngine, ttsModel?: string | null, stylePrompt: string, customHostName?: string | null, customHostPersonality?: string | null, s3IntroPath?: string | null, s3OutroPath?: string | null, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isActive: boolean, visibility: TopicVisibility, cronSchedule?: string | null, status: TopicStatus, episodeCount: number, lastIngestionAt?: any | null, lastExecutionId?: string | null, lastExecutionStatus?: ExecutionStatus | null, lastExecutionStartedAt?: any | null, createdAt: any, createdBy?: string | null, updatedAt: any, updatedBy?: string | null, canTriggerIngestion: boolean, sources: Array<{ __typename?: 'Source', sourceType: SourceType, identifier: string, label?: string | null, domainFilter?: string | null }>, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, publishedAt: any } }> } } | null } };

export type TopicCardFieldsFragment = { __typename?: 'Topic', slug: string, name: string, isActive: boolean, episodeCount: number, spotifyUrl?: string | null, applePodcastsUrl?: string | null, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', episodeId: string, title: string, summary: string, audioS3Key: string, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> } }> } };

export type GetPublicTopicsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPublicTopicsQuery = { __typename?: 'QueryRoot', topics: { __typename?: 'TopicConnection', edges: Array<{ __typename?: 'TopicEdge', node: { __typename?: 'Topic', slug: string, name: string, isActive: boolean, episodeCount: number, spotifyUrl?: string | null, applePodcastsUrl?: string | null, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', episodeId: string, title: string, summary: string, audioS3Key: string, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> } }> } } }> } };

export type EpisodeFieldsFragment = { __typename?: 'Episode', id: string, topicSlug: string, episodeId: string, title: string, summary: string, audioS3Key: string, transcript: string, sourceLinks: Array<string>, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type GetEpisodesQueryVariables = Exact<{
  topicSlug: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEpisodesQuery = { __typename?: 'QueryRoot', topic?: { __typename?: 'Topic', episodes: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', cursor: string, node: { __typename?: 'Episode', id: string, topicSlug: string, episodeId: string, title: string, summary: string, audioS3Key: string, transcript: string, sourceLinks: Array<string>, durationSeconds: number, publishedAt: any, chapters: Array<{ __typename?: 'Chapter', id: string, title: string, startTimeMs: number, endTimeMs: number, description?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } | null };

export type GetHomepageDataQueryVariables = Exact<{
  topicsFirst?: InputMaybe<Scalars['Int']['input']>;
  episodesFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomepageDataQuery = { __typename?: 'QueryRoot', topics: { __typename?: 'TopicConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TopicEdge', node: { __typename?: 'Topic', slug: string, name: string, episodeCount: number, spotifyUrl?: string | null, applePodcastsUrl?: string | null, isFollowedByViewer?: boolean | null, followerCount: number, latestEpisode: { __typename?: 'EpisodeConnection', edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', episodeId: string, publishedAt: any } }> } } }> }, episodes: { __typename?: 'EpisodeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EpisodeEdge', node: { __typename?: 'Episode', id: string, topicSlug: string, episodeId: string, title: string, summary: string, audioS3Key: string, durationSeconds: number, publishedAt: any, isLikedByViewer?: boolean | null, likeCount: number } }> } };

export type TenantFieldsFragment = { __typename?: 'Topic', slug: string, name: string, stylePrompt: string, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null };

export type GetTenantQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetTenantQuery = { __typename?: 'QueryRoot', topic?: { __typename?: 'Topic', slug: string, name: string, stylePrompt: string, s3AnchorImagePath?: string | null, spotifyUrl?: string | null, applePodcastsUrl?: string | null } | null };

export const PromptConfigFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromptConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromptConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"bedrockPromptName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<PromptConfigFieldsFragment, unknown>;
export const SourceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}}]} as unknown as DocumentNode<SourceFieldsFragment, unknown>;
export const TopicFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEngine"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModel"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"customHostName"}},{"kind":"Field","name":{"kind":"Name","value":"customHostPersonality"}},{"kind":"Field","name":{"kind":"Name","value":"s3IntroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3OutroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cronSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastIngestionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStartedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"canTriggerIngestion"},"name":{"kind":"Name","value":"canAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"TRIGGER_INGESTION"}}]},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}}]} as unknown as DocumentNode<TopicFieldsFragment, unknown>;
export const TopicSummaryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicSummaryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<TopicSummaryFieldsFragment, unknown>;
export const TopicCardFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicCardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TopicCardFieldsFragment, unknown>;
export const EpisodeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpisodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Episode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLinks"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<EpisodeFieldsFragment, unknown>;
export const PageInfoFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<PageInfoFieldsFragment, unknown>;
export const TenantFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}}]}}]} as unknown as DocumentNode<TenantFieldsFragment, unknown>;
export const UpdateEpisodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEpisode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEpisodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEpisode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpisodeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpisodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Episode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLinks"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;
export const GetEpisodeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpisodeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpisodeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpisodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Episode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLinks"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetEpisodeByIdQuery, GetEpisodeByIdQueryVariables>;
export const GetPromptTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPromptTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promptTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromptConfigFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromptConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromptConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"bedrockPromptName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetPromptTemplateQuery, GetPromptTemplateQueryVariables>;
export const UpdatePromptTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePromptTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePromptConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePromptTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promptTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromptConfigFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromptConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PromptConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"bedrockPromptName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdatePromptTemplateMutation, UpdatePromptTemplateMutationVariables>;
export const GetTopicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEngine"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModel"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"customHostName"}},{"kind":"Field","name":{"kind":"Name","value":"customHostPersonality"}},{"kind":"Field","name":{"kind":"Name","value":"s3IntroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3OutroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cronSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastIngestionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStartedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"canTriggerIngestion"},"name":{"kind":"Name","value":"canAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"TRIGGER_INGESTION"}}]},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]} as unknown as DocumentNode<GetTopicsQuery, GetTopicsQueryVariables>;
export const GetTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEngine"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModel"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"customHostName"}},{"kind":"Field","name":{"kind":"Name","value":"customHostPersonality"}},{"kind":"Field","name":{"kind":"Name","value":"s3IntroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3OutroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cronSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastIngestionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStartedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"canTriggerIngestion"},"name":{"kind":"Name","value":"canAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"TRIGGER_INGESTION"}}]},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]} as unknown as DocumentNode<GetTopicQuery, GetTopicQueryVariables>;
export const CreateTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicSummaryFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicSummaryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CreateTopicMutation, CreateTopicMutationVariables>;
export const SetTopicActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetTopicActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetTopicActiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setTopicActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SetTopicActiveMutation, SetTopicActiveMutationVariables>;
export const UpdateTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEngine"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModel"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"customHostName"}},{"kind":"Field","name":{"kind":"Name","value":"customHostPersonality"}},{"kind":"Field","name":{"kind":"Name","value":"s3IntroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3OutroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cronSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastIngestionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStartedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"canTriggerIngestion"},"name":{"kind":"Name","value":"canAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"TRIGGER_INGESTION"}}]},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]} as unknown as DocumentNode<UpdateTopicMutation, UpdateTopicMutationVariables>;
export const DeleteTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedTopicId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteTopicMutation, DeleteTopicMutationVariables>;
export const GenerateUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateUploadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateUploadUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateUploadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;
export const TriggerIngestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerIngestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerIngestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerIngestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<TriggerIngestionMutation, TriggerIngestionMutationVariables>;
export const DeleteEpisodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEpisode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteEpisodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEpisode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedEpisodeId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SourceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Source"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"domainFilter"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SourceFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEngine"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModel"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"customHostName"}},{"kind":"Field","name":{"kind":"Name","value":"customHostPersonality"}},{"kind":"Field","name":{"kind":"Name","value":"s3IntroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3OutroPath"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cronSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastIngestionAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastExecutionStartedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"canTriggerIngestion"},"name":{"kind":"Name","value":"canAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"TRIGGER_INGESTION"}}]},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]} as unknown as DocumentNode<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>;
export const GetPublicTopicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicTopics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicCardFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicCardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPublicTopicsQuery, GetPublicTopicsQueryVariables>;
export const GetEpisodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpisodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topicSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topicSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpisodeFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfoFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpisodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Episode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLinks"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"endTimeMs"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<GetEpisodesQuery, GetEpisodesQueryVariables>;
export const GetHomepageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHomepageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topicsFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"episodesFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topicsFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"visibility"},"value":{"kind":"EnumValue","value":"PUBLIC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"episodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isFollowedByViewer"}},{"kind":"Field","name":{"kind":"Name","value":"followerCount"}},{"kind":"Field","alias":{"kind":"Name","value":"latestEpisode"},"name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"episodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"episodesFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicSlug"}},{"kind":"Field","name":{"kind":"Name","value":"episodeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"audioS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByViewer"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetHomepageDataQuery, GetHomepageDataQueryVariables>;
export const GetTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Topic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stylePrompt"}},{"kind":"Field","name":{"kind":"Name","value":"s3AnchorImagePath"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applePodcastsUrl"}}]}}]} as unknown as DocumentNode<GetTenantQuery, GetTenantQueryVariables>;